import { useCallback, memo } from 'react';
import { Linking } from 'react-native';
import { ChatButton } from '@bonanza-social/shared/components';
import { Box, Text, Button, BoxProps } from '@bonanza-social/moonlight';
import { useLocation } from '@bonanza-social/navigation';
import { ContactUsFormState } from './ContactUsForm.types';
import { PARTNERSHIPS } from './ContactUsForm.constants';

function ContactUsForm(props: BoxProps) {
  const { state } = useLocation() as Location & { state: ContactUsFormState };

  const shareViaEmail = useCallback(() => {
    if (state?.from === PARTNERSHIPS) {
      Linking.openURL(encodeURI('mailto:partnerships@bonanzasocial.com'));
    } else {
      Linking.openURL(encodeURI('mailto:support@bonanzasocial.com'));
    }
  }, [state?.from]);

  return (
    <Box {...props} paddingLeft={'space-400'} paddingRight={'space-400'}>
      <Text
        variant="body-l"
        gradient="darkSurfaceAccent"
        locNS="account"
        locKey="titleContactUs"
        padding="space-600"
        marginLeft="-space-600"
      />
      <Box gap="space-500" flexDirection="column">
        <Text
          variant="body-m"
          color="darkSurfacePrimary"
          locNS="account"
          locKey="contactUs"
          paddingBottom="space-400"
        />
      </Box>
      <Box gap="space-200" marginBottom="space-400">
        <ChatButton />
        <Button
          variant="secondary"
          locNS="account"
          locKey="emailShare"
          onPress={shareViaEmail}
          alignSelf="center"
          width="100%"
        />
      </Box>
    </Box>
  );
}

export default memo(ContactUsForm);
